import { Box, Typography } from '@mui/material';
import { type FC, useEffect } from 'react';
// hooks
import logoSecondary from 'assets/icons/logo-secondary.svg';
import { withRailBasename } from 'helpers/rail';

const MaintenanceStaticPage: FC = () => {
  useEffect(() => {
    // Set up a timer to redirect to root URL every 10 minutes (600,000 milliseconds)
    const redirectTimer = setInterval(
      () => {
        window.location.href = withRailBasename('/');
      },
      10 * 60 * 1000,
    ); // 10 minutes in milliseconds

    // Cleanup timer on component unmount
    return () => {
      clearInterval(redirectTimer);
    };
  }, []);

  return (
    <>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          height: '100vh',
          color: (theme) => theme.palette.primary.main,
        }}
      >
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            height: '240px',
            background: (theme) => theme.palette.customColors.gunMetal,
            overflow: 'hidden',
            width: 1,
          }}
        >
          <Box
            component="img"
            src={logoSecondary}
            sx={{
              width: 200,
              height: 200,
            }}
          />
          <Typography
            sx={{
              color: (theme) => theme.palette.common.white,
              pb: 2,
            }}
            variant="h2"
          >
            Maintenance Mode
          </Typography>
        </Box>
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            height: '100%',
            background: (theme) => theme.palette.customColors.lightGray,
            overflow: 'hidden',
            width: 1,
          }}
        >
          <Box sx={{ textAlign: 'center', mt: 3, maxWidth: 800 }}>
            <Typography
              variant="body1"
              sx={{
                display: 'inline',
                whiteSpace: 'pre-wrap',
              }}
            >
              The system is under maintenance. Please try again later.
            </Typography>
          </Box>
        </Box>
      </Box>
    </>
  );
};

export default MaintenanceStaticPage;
